module.exports = __webpack_public_path__ + "static/media/pollution.bb37c232.svg";